<app-icon class="text-24 bg-grey-hover-20 text-grey-70"
  [name]="icon"
  [class.selected]="selected"
  [attr.title]="selected ? titleCancel : title"
  (mouseenter)="onEnter()"
  (mouseleave)="onLeave()"
  (click)="onClick()">
</app-icon>
